<template>
    <v-dialog
        v-model="dialog"
        max-width="920"
    >
        <v-card>
            <v-card-title class="headline">
                Create New Bulk Message
            </v-card-title>

            <v-card-text>

                <v-text-field
                    label="Name"
                    v-model="bulk_message_label"
                    autocomplete="off"
                    autofocus
                >
                </v-text-field>

                <p>
                    <b>Naming Suggestion:  </b>  Bulk messages are frequently copied and reused later.  Because of this, it is a good idea to use a descriptive name that include the month and year.
                </p>
                <p>
                    For example: <u>Credit Card Declines</u> is a descriptive name for a message, but a better name would be <u>December 2023 Credit Card Declines</u>.
                </p>

                <a
                    v-on:click="onClickTechnicalDetails"
                >
                    Technical Details
                </a>

            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    text
                    @click="dialog = false;"
                >
                    Cancel
                </v-btn>

                <v-btn
                    color="primary darken-1"
                    text
                    @click="onOk"
                    :disabled="!isValid()"
                >
                    Ok
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
const { v4: uuidv4 } = require('uuid');
const _ = require('lodash');
export default {
    data() {
        return {
            organization_id: null,
            bulk_message_label: '',
            template_bulk_message: null,
            dialog: false,
        }
    },

    methods: {

        showDialog(organization_id)
        {
            this.organization_id = organization_id;
            this.bulk_message_label = '';
            this.dialog = true;
        },

        isValid()
        {
            if ( this.bulk_message_label == null || this.bulk_message_label == '' || this.bulk_message_label.trim() == '' ) return false;
            return true;
        },

        onOk() {
            this.dialog = false;
          
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/bulk/create-stub',
            
                'params' : {
                        'organization_id' : this.organization_id,
                        'label' : this.bulk_message_label,
                        'use_legacy_variables': false,
                    },
            
                'on_success': (data) => {
                        
                        if ( data.filter_order_history != null )
                        {
                            this.onOkWarnOrderHistory(data);
                        }
                        else
                        {
                            this.$emit('upsert_bulk_message',data);
                        }
                    },
            
                'on_error': 'Unable to create new bulk message',
            });
        },

        onOkWarnOrderHistory(new_bulk_message)
        {
            this.$rc.warn({
                'warning_code': 'order_history_filter',
                'title': 'New Filter Options!',
                'text': '<p>Automate more and worry less: RedChirp has new ways to filter bulk message recipients.</p><p>By default, new bulk messages will try to avoid sending on holidays — or at times  — restricted by any state(s) associated with each recipient. RedChirp associates state(s) with each phone number by area code, customer profiles, and all orders known to RedChirp via your integrations.</p><p>By default, new bulk messages will try to only send to recipients who have consent on file in RedChirp OR have purchased within the last 18 months.</p><p>You can customize the number of months, make these filters more or less restrictive, or choose not to use them at all, per bulk message.</p>',
                'label_ok': 'Ok',
                'label_cancel': null,
                'label_dismiss': 'Do not show again',

                'on_ok': () => {
                    this.$emit('upsert_bulk_message',new_bulk_message);
                }
            });
        },

        onClickTechnicalDetails()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/bulk/create-stub',
            
                'params' : {
                        'organization_id' : this.organization_id,
                        'label' : this.bulk_message_label,
                        'use_legacy_variables': false,
                        'is_preview': true,
                    },
            
                'on_success': (data) => {

                        this.$rc.technicalDetails({
                            'title': 'Technical Details',
                            'technical_details': data.technical_details,
                        });
                    },
            
                'on_error': 'Unable to get technical details',
            });
        },
    },
}
</script>